import moment from "moment";
import { ActionContext } from "vuex";
import { CompanyStateInterface } from "./types";
import Company from "@/types/app/companies";

moment.locale("en-US");
export default {  

  setModalCompanyState(
    store: ActionContext<CompanyStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalCompanyState", show);
  },  
  setCompanyState(
    store: ActionContext<CompanyStateInterface, any>,
    company: Company
  ) {
    store.commit("setCompanyState", company);
  },
  setCompaniesState(
    store: ActionContext<CompanyStateInterface, any>,
    companies: Company[]
  ) {
    store.commit("setCompaniesState", companies);
  },
  seCompanySent(
    store: ActionContext<CompanyStateInterface, any>,
    show: boolean
  ) {
    store.commit("setCompanySent", show);
  } 
  
};

